export const STORE_SERVICES_PREFIX = "StoreServices";

export const STORE_SERVICES_CLASSES = {
  title: `${STORE_SERVICES_PREFIX}-title`,
};
